const page = `
{settings}
document.title: USA:s nye president – här är Trumps liv i bilder | SVT Nyheter
og.title: Från politisk outsider till president
og.image: http://quickshot.imgix.net/trumps-liv-i-bilder/yngsta.jpg

og.twitterImage: http://quickshot.imgix.net/trumps-liv-i-bilder/yngsta.jpg?h=120&w=120&fit=crop&&fp-x=0
og.description: Han är fastighetsmiljardären som blev kasinomogul och tv-stjärna. Redan 1987 nämns Donald Trumps namn för jobbet som en av världens mäktigaste. 2000 försöker han kandidera, men misslyckas. Sex år senare är Donald Trump USA:s president. Här är hans liv, och karriär, i bilder.
og.url: http://pejl.svt.se/trumps-liv-i-bilder

siteCatalyst.name: trumps-liv-i-bilder
siteCatalyst.category: lyxartikel
{}
[+page]
rubrikxl: Från politisk outsider till president
ingress: Han är fastighetsmiljardären som blev kasinomogul och tv-stjärna. Redan 1987 nämns Donald Trumps namn för jobbet som en av världens mäktigaste. 2000 försöker han kandidera, men misslyckas. Sex år senare är Donald Trump USA:s president. Här är hans liv, och karriär, i bilder.
{.bild}
storlek:lwide
foto: TT/AP
fil:trumps-liv-i-bilder/yngsta.jpg
bildtext: Donald J Trump, den fjärde sonen till fastighetsmagnaten Fred Trump, följer i sin fars fotspår. 1971 tar han helt över familjeföretaget med fastigheter i New York City och döper om det till Trump Organization. Här poserar han med en ritning av ett nytt projekt, 1985.
{}
{.bild}
storlek:lwide
foto: TT/AP
fil:trumps-liv-i-bilder/trumpwarhol.jpg
bildtext: Donald Trump engagerar sig tidigt i flera sporter, bland annat wrestling och boxning. Här syns han i samband med en tävling i hästpolo tillsammans med konstnären Andy Warhol, 1983.
{}
{.bild}
storlek:xlwide
fil:trumps-liv-i-bilder/helikopter.jpg
{}
luft:-48
{.bild}
storlek:xlwide
foto: TT/AP
fil:trumps-liv-i-bilder/privatplan.jpg
bildtext: Donald Trump har gjort sig känd för att under presidentkampanjen flyga in med flygplanet som bär hans namn, men det är inget nyhet för affärsmiljardären. Här poserar han redan 1988 med en av sina tre helikoptrar. På bilden under går han ombord sitt privatplan i New York.
{}
{.bild}
storlek:lwide
foto: TT/AP
fil:trumps-liv-i-bilder/ungtrump1.jpg
bildtext: Efter att ha tagit över familjeföretaget 1971 utökar Trump verksamheten rejält, både inom fastighetsindustrin – men han ägnade sig även åt hotell och kasinon. Här väntar han tillsammans med sin bror Robert på ett möte i Atlantic City för att få bygga "Taj Mahal Casino", ett av världens största kasinokomplex.
{}
{.bild}
storlek:xlwide
foto: TT/AP
fil:trumps-liv-i-bilder/trumpcasino.jpg
bildtext: Och ett kasino blir det. Här invigs det enorma komplexet som Trump själv kallar "världens åttonde underverk" i Atlantic City, den 29 mars 1990. 26 år senare stängs kasinot av en annan kasinomiljadär – Trumps vän Carl Ichan.
{}
{.bild}
storlek:lwide
foto: TT/AP
fil:trumps-liv-i-bilder/princessbat.jpg
bildtext: Donald Trump har varit gift tre gånger och har fem barn. Här poserar han med sin första fru, Ivana Trump, som han fick tre barn tillsammans med.
{}
{.bild}
storlek:lwide
foto: TT/AP
fil:trumps-liv-i-bilder/trumptyson.jpg
bildtext: Boxarkungen Mike Tyson under en presskonferens 1988 tillsammans med sin rådgivare – Donald Trump.
{}
{.bild}
storlek:xlwide
fil:trumps-liv-i-bilder/modeller.jpg
{}
luft:-48
{.bild}
storlek:xlwide
foto: TT/AP
fil:trumps-liv-i-bilder/missusa.jpg
bildtext: Förutom fastigheter, hotell och kasinon har Trump även byggt upp ett imperium i nöjesindustrin. Mellan 1996 och 2015 äger han tävlingarna Miss Universe, Miss USA och Miss Teen USA. Här poserar han bland annat tillsammans med några av de som tävlade om delstats-titeln på sin yacht, i Atlantic City 1988. På bilden nedanför tillsammans med Miss USA.
{}
{.bild}
storlek:lwide
foto: TT/AP
fil:trumps-liv-i-bilder/signerarbok.jpg
bildtext: Det har svajat rejält kring Donald Trumps enorma fastighetsimperium flera gånger, vid minst fyra tillfällen har miljardären begärt sitt företag i konkurs. Han har även skrivit flera böcker om sitt liv. Här signerar han en av dem, "Surviving at the top", 1990.
{}
{.bild}
storlek:lwide
foto: TT/AP
fil:trumps-liv-i-bilder/trumpmarbles.jpg
bildtext: Tillsammans med sin andra hustru Marla Marples och skådespelaren Elliot Gould besöker Donald Trump här en match med New York-laget Knicks i Madison Square Garden, 1991.
{}
{.bild}
storlek:lwide
foto: TT/AP
fil:trumps-liv-i-bilder/trumpivanka.jpg
bildtext: Tillsammans med ex-hustrun Ivana Trump har Donald Trump tre barn, två söner och dottern Ivanka. Här kikar far och dotter ut över publiken under en tennismatch i US Open i New York 1994.
{}
{.bild}
storlek:lwide
foto: TT/AP
fil:trumps-liv-i-bilder/nyfru.jpg
bildtext: Den tredje hustrun och hans nuvarande, Melania, gifter sig Donald Trump med 2005. Här syns de tillsammans under en tennismatch i New York 1999.
{}
{.bild}
storlek:xlwide
foto: TT/AP
fil:trumps-liv-i-bilder/tompk.jpg
bildtext: Första gången Trumps namn nämns i spekulationerna om vilka som ska kandidera till posten som USA:s president är 1987, men han ställer aldrig upp. Tretton år senare gör han ett försök som kandidat för "Reform Party". Intresset på presskonferensen i Beverly Hills är dock svalt.
{}
{.bild}
storlek:lwide
foto: TT/AP
fil:trumps-liv-i-bilder/fired.jpg
bildtext: 2003 debuterar Donald Trump som tv-stjärna i NBC-serien "The Apprentice" där ett gäng hoppfulla personer tävlar om ett chefsjobb inom Trumps organisation. Kanske mest känt från serien är när Trump skickar ut någon, med kommentaren "You're fired".
{}
{.bild}
storlek:lwide
foto: TT/AP
fil:trumps-liv-i-bilder/familjen.jpg
bildtext: Barnen från Trumps första äktenskap, längst till vänster Donald Trump Jr och längst till höger Ivanka Trump, har på senare år varit med och drivit företaget Trump Organization tillsammans med sin pappa – och brodern Eric.
{}
{.bild}
storlek:lwide
foto: TT/AP
fil:trumps-liv-i-bilder/nyatvillingtorn.jpg
bildtext: Trump presenterar under en presskonferens 2005 ett förslag till ett nytt World Trade Center, "Twin towers II", efter att tvillingtornen förstörts i terrorattacken den 11 september fyra år tidigare.
{}
{.bild}
storlek:lwide
foto: TT/AP
fil:trumps-liv-i-bilder/starhollywood.jpg
bildtext: 2007 hamnar hans namn på en av världens mest berömda gator. Donald Trump poserar tillsammans med sin fru Melania och deras gemensamma dotter Barron på Hollywood Walk of fame.
{}
{.bild}
storlek:xlwide
foto: TT/AP
fil:trumps-liv-i-bilder/rakarmotstand.jpg
bildtext: Trump syns i medierna även innan hans politiska karriär, men av andra anledningar. Här rakar han av håret på chefen för världens största wrestlingförbund, WWE, efter att hans brottare förlorat en match i Detroit 2007.
{}
{.bild}
storlek:lwide
foto: TT/AP
fil:trumps-liv-i-bilder/faderdotter.jpg
bildtext: Under 2000-talet fortsätter Trumps imperium att växa, han fortsätter att bygga sina "Trump towers" på flera platser i världen. Här inviger han en av byggnaderna, Trump international hotel and tower, i Chicago 2008 tillsammans med dottern Ivanka.
{}
{.bild}
storlek:lwide
foto: TT/AP
fil:trumps-liv-i-bilder/snoop.jpg
bildtext: Donald Trump hälsar på rapparen Snoop Dogg i samband med inspelningen av ett tv-program i New York 2011.
{}
{.bild}
storlek:xlwide
foto: TT/AP
fil:trumps-liv-i-bilder/apprentice.jpg
bildtext: Donald Trump leder programmet "The apprentice" under 14 säsonger. Här poserar han tillsammans med bland andra skådespelarna Stephen Baldwin och Dennis Rodman i samband med inspelningen av en kändisspecial av programmet, i New York 2012.
{}
{.bild}
storlek:lwide
fil:trumps-liv-i-bilder/trappan.jpg
{}
luft:-48
{.bild}
storlek:lwide
foto: TT/AP
fil:trumps-liv-i-bilder/trorpatrump.jpg
bildtext: Efter att ha flirtat med att kandidera för det republikanska partiet under en tid kommer till slut beskedet under en presskonferens i Trump Tower på Manhattan i New York. Här gör huvudpersonen, Donald Trump, entré genom att komma ned med rulltrappan till en spänd publik, i juni 2015.
{}
{.bild}
storlek:lwide
foto: TT/AP
fil:trumps-liv-i-bilder/presidentkandidat.jpg
bildtext: "Make America great again". Orden som ska komma att bli kännetecknet för hans presidentkampanj. USA behöver en ledare som kan göra landet stort och starkt igen, säger Trump under sin presskonferens. Han visar även upp en kopia på hur mycket han är god för.
{}
{.bild}
storlek:xlwide
foto: TT/AP
fil:trumps-liv-i-bilder/trumpdebatt.jpg
bildtext: Under primärvalen är tonen många gånger stenhård. Här deltar Donald Trump i en debatt tillsammans med de andra republikanska kandidaterna – John Kasich, Mike Huckabee, Jeb Bush, Marco Rubio och Ben Carson – i oktober 2015.
{}
{.bild}
storlek:lwide
foto: TT/AP
fil:trumps-liv-i-bilder/famioljen.jpg
bildtext: Familjen, och kanske särskilt barnen, är nyckelpersoner under Trumps kampanjer – både under primärvalet och presidentvalet. Här sitter Ivanka, Donald Jr och Eric Trump tillsammans med hustrun Melania under ett av Donald Trumps framträdanden.
{}
{.bild}
storlek:lwide
foto: TT/AP
fil:trumps-liv-i-bilder/christiesur.jpg
bildtext: Många av de andra kandidaterna skräder inte sina ord under primärvalen när det gällde Donald Trump, men när det står klart att han är det Republikanska partiets kandidat får han stöd av flera. En av de mest uppmärksammade bilderna är den här, på New Jerseys guvernör Chris Christie som ser något snopen ut efter att ha gett Trump sitt stöd.
{}
{.bild}
storlek:lwide
foto: TT/AP
fil:trumps-liv-i-bilder/debatt.jpg
bildtext: De sista två. Donald Trump och Demokraternas Hillary Clinton under en av debatterna i presidentvalet - ett val som kännetecknats av att ha varit smutsigare än någonsin. Påhoppen och skandalerna har varit i fokus både under primärvalet men också i slutspurten mellan de två presidentkandidaterna.
{}
{.bild}
storlek:xlwide
foto: TT/AP
fil:trumps-liv-i-bilder/trumnastsista.jpg
bildtext: Donald Trump har själv kallat sin kampanj för en rörelse. Hela världen har fått se hur mannen, som till en början många kritiker skrattade åt, har vuxit till att bli en person som många amerikaner velat se som landets nästa ledare. Här under ett av sina kampanjmöten, omgiven av supportrar.
{}
{.bild}
storlek:lwide
foto: TT/AP
fil:trumps-liv-i-bilder/trumpvunnit.jpg
bildtext: Så var det klart. Vid klockan 08.30 svensk tid den 9 november 2016 har Donald Trump slagit Hillary Clinton, och med det vunnit kampen om att bli USA:s 45:e president.
{}
{.bild}
storlek:lwide
foto: TT/AP
fil:trumps-liv-i-bilder/skakahand.jpg
bildtext: Obama visste nog inte hur rätt han skulle få när han skämtsamt uttalade orden "säga vad man vill om Mr Trump, han skulle sannerligen föra med sig förändring till Vita Huset", under sitt årliga tal på korrespondentmiddagen 2011. Här möts de under ett första möte i presidentbostaden.
{}
linje:
{.sharebuttons}
title:USA:s nye president – här är Trumps liv i bilder
url:http://pejl.svt.se/trumps-liv-i-bilder
{}
rubrik5: Ella Berger
luft: -50
[ella.berger@svt.se | mailto:ella.berger@svt.se]
luft:50
[]
`;
export default page;



/** WEBPACK FOOTER **
 ** ./~/eslint-loader!./src/data/articles/trumps-liv-i-bilder.js
 **/